import React from 'react';
import { motion } from 'framer-motion';
export function DecisionBlock() {
  return <section className="py-24 px-4 bg-mystic-800 relative overflow-hidden" data-id="element-76">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-lilac-500/10 via-mystic-800 to-mystic-800 pointer-events-none" data-id="element-77" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-79">
          <p className="text-2xl md:text-4xl font-serif text-slate-300 mb-6 leading-relaxed" data-id="element-80">
            El próximo vínculo puede ser <br className="hidden md:block" data-id="element-81" />
            otra herida que te cueste meses superar...
          </p>
          <p className="text-3xl md:text-5xl font-serif font-bold text-gold-400 mb-10 italic" data-id="element-82">
            o el inicio de tu nueva versión.
          </p>
          <p className="text-xl md:text-2xl font-bold text-white uppercase tracking-widest" data-id="element-83">
            Vos decidís.
          </p>
        </motion.div>
      </div>
    </section>;
}